import './styles/_secondary-navigation.scss';
import { onDocumentReady } from '../utils/dom';

const state = {
  elements: {},
};

const cacheState = () => {
  state.elements = {
    navigationSection: document.querySelector('.navigation-section'),
    sectionHeader: document.querySelector('.section-header'),
    navigationLinks: document.querySelectorAll('.navigation__link'),
  };
};

const scrollToSection = (targetId) => {
  const targetSection = document.querySelector(`[data-id="${targetId}"]`);
  if (targetSection) {
    targetSection.scrollIntoView({ behavior: 'smooth' });
  }
};

const handleScroll = (
  navigationSection,
  sectionHeaderHeight,
  navigationLinks
) => {
  let lastScrollTop = 0;
  const navOffsetTop = navigationSection.offsetTop;

  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop >= navOffsetTop) {
      updateNavigationPosition(
        scrollTop,
        lastScrollTop,
        sectionHeaderHeight,
        navigationSection
      );
    } else {
      navigationSection.classList.remove('scroll-up', 'scroll-down');
      navigationSection.style.top = '';
    }

    highlightActiveLink(scrollTop, navigationLinks, sectionHeaderHeight);
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  });
};

const updateNavigationPosition = (
  scrollTop,
  lastScrollTop,
  sectionHeaderHeight,
  navigationSection
) => {
  if (scrollTop > sectionHeaderHeight) {
    if (scrollTop > lastScrollTop) {
      navigationSection.classList.remove('scroll-up');
      navigationSection.classList.add('scroll-down');
      navigationSection.style.top = 0;
    } else {
      navigationSection.classList.remove('scroll-down');
      navigationSection.classList.add('scroll-up');
      navigationSection.style.top = `${sectionHeaderHeight}px`;
    }
  } else {
    navigationSection.classList.remove('scroll-up', 'scroll-down');
    navigationSection.style.top = 0;
  }
};

const highlightActiveLink = (
  scrollTop,
  navigationLinks,
  sectionHeaderHeight
) => {
  navigationLinks.forEach((link) => {
    const targetId = link.getAttribute('href').substring(1);
    const targetSection = document.querySelector(`[data-id="${targetId}"]`);

    if (
      targetSection &&
      scrollTop >= targetSection.offsetTop - sectionHeaderHeight &&
      scrollTop < targetSection.offsetTop + targetSection.offsetHeight
    ) {
      navigationLinks.forEach((l) => l.classList.remove('active'));
      link.classList.add('active');
    }
  });
};

const handleLinkClick = (navigationLinks) => {
  navigationLinks.forEach((link) => {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      const targetId = this.getAttribute('href').substring(1);

      if (targetId) {
        history.pushState(null, null, `#${targetId}`);
        scrollToSection(targetId);
      }
    });
  });
};

const handleHashOnLoad = (navigationLinks) => {
  const { hash } = window.location;
  if (hash) {
    const targetId = hash.substring(1);
    const targetLink = [...navigationLinks].find(
      (link) => link.getAttribute('href') === `#${targetId}`
    );
    if (targetLink) {
      scrollToSection(targetId);
    }
  }
};

const attachEventListeners = () => {
  const sectionHeaderHeight = state.elements.sectionHeader.offsetHeight;

  handleScroll(
    state.elements.navigationSection,
    sectionHeaderHeight,
    state.elements.navigationLinks
  );
  handleLinkClick(state.elements.navigationLinks);
  handleHashOnLoad(state.elements.navigationLinks);
};

const init = () => {
  cacheState();
  attachEventListeners();
};

onDocumentReady(init);